/*=========================================================================================
  File Name: moduleCustomerActions.js
  Description: Customer Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

import axios from "@/plugins/axios";


export default {
  //reset the password by get token from api


  async CreateDish({}, Credentials) {
    
    
    return new Promise((resolve, reject) => {
      axios
        .post("hms/dishes", Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  async GetSingleOrder({}, Id) {
    let url=`hms/orders/${Id}`
    
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  async UploadDishImage({}, Credentials) {
    console.log(Credentials.get("id"));
    return new Promise((resolve, reject) => {
      axios
        .post(`hms/dishes/${Credentials.get("id")}/image-upload`, Credentials)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  async GetDishes({}) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/dishes`)
        .then((resp) => {
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
 
   async GetUnits({}) {
     
    return new Promise((resolve, reject) => {
      axios
        .get(`hrm/units`)
        .then((resp) => {
          
          console.log("Request succeeded");
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  async EditDish({}, Credentials) {
    
    let dishId = Credentials.id;
    delete Credentials.id;
    
    return new Promise((resolve, reject) => {
      axios
        .patch(`hms/dishes/${dishId}`, Credentials)
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },

  async GetSingleDish({}, Id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/dishes/${Id}`)
        .then((resp) => {
        
          resolve(resp);
        })
        .catch((err) => {
          console.log("Error");
          reject(err.response);
        });
    });
  },
  ArchiveOrActiceDish({}, Credentials) {
    return new Promise((resolve, reject) => {
      axios
        .get(`hms/dishes/${Credentials.id}/soft-delete`)
        .then((resp) => {
          console.log("resp.data", resp.data.data);
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },

 


  GetDishSearch({}, payload) {
    let url = "hms/guests/search?";
    if (payload != null && payload != undefined) {
      if (payload.query != "" && payload.query != null) {
        url += `query=${payload.query}&`;
      }
      if (payload.status != "" && payload.status != null) {
        url += `status=${payload.status}&`;
      }

      if (
        payload.except != undefined &&
        payload.except != null &&
        payload.except.length > 0
      ) {
        url += `except=[${payload.except}]`;
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(url)
        .then((resp) => {
          resolve(resp.data.data);
        })
        .catch((err) => {
          reject(err.response);
        });
    });
  },


};
